export default __webpack_public_path__ + "static/media/logo.ae6029a9.svg";